import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWritePolicyOwnerInformation: Map<string, ConfirmationData> = new Map([
    ["1fca63f2-8cf8-4de3-b517-3a426181acae", { hidden: true }],
    ["fb2dd4bb-24bb-4700-89bb-a53f014ef25b", { hidden: true }],
    ["f8b09001-05cc-40c5-b9b0-4361c2013d2a|32c72e92-0aa6-4582-a1fa-737c243ed69f", { fontWeight: "bold", showBorder: true }],
    ["f8b09001-05cc-40c5-b9b0-4361c2013d2a|773e8c82-3c69-4745-8520-43ac32b1b030", { fontWeight: "bold", showBorder: true }],
    ["f8b09001-05cc-40c5-b9b0-4361c2013d2a|84f4b5e2-a240-4405-839b-a35924df2fa8", { fontWeight: "bold", showBorder: true }],
    ["f8b09001-05cc-40c5-b9b0-4361c2013d2a|a1c1f62e-326b-46f0-bb7d-33d436ca267d", { fontWeight: "bold", showBorder: true }],
    ["f8b09001-05cc-40c5-b9b0-4361c2013d2a|103a15f4-0d02-496a-bf0f-994ee9e4b945", { fontWeight: "bold", showBorder: true }],  
    ["f8b09001-05cc-40c5-b9b0-4361c2013d2a|1170127e-b2ff-4665-944d-622f44da403e", { fontWeight: "bold", showBorder: true }],


    ["c3bf0fec-c12d-4930-ab5c-ce58bd8da169|212d0aac-8bd4-45c5-8dd8-45392faaeb87", { hidden: true }],
]);



